module.exports = __webpack_public_path__ + "img/filter_list.39239611.svg";